export default __webpack_public_path__ + "static/media/notFoundMark.f6ed6cbd.svg";